import _ from 'lodash';

type Topics = {
  [topic: string]: {
    [questionId: string]: {
      type: string,
      key: string,
      label: string
    };
  };
}

export const getTopicsByQuestion = (questionId: string, topicsObject: Topics) => {
  const topics = _.keys(topicsObject);
  const assessedTopics: string[] = [];

  _.forEach(topics, (topic) => {
    if (_.has(topicsObject[topic], questionId)) {
      assessedTopics.push(topic);
    }
  });

  return assessedTopics;
};
